import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { X, MapPin, Building2, Users } from "lucide-react";

/** Fix W (2026-09-11): detalle real detrás de las tarjetas "Sedes activas" y
 * "Clientes activos" del inicio -- mismos números que la métrica (no cambia
 * la forma de contar), ahora se puede ver el listado y entrar a la ficha. */
export function SitesOverviewModal({ mode, onClose }) {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try { const { data: d } = await api.get("/clients/sites-overview"); setData(d); }
      catch (e) { setErr(formatApiError(e)); toast.error(formatApiError(e)); }
    })();
  }, []);

  const totalSites = data ? data.reduce((a, c) => a + c.sites.length, 0) : 0;
  const goToSite = (clientId, siteId) => { onClose(); nav(`/admin/clientes/${clientId}?tab=sites&site=${siteId}`); };
  const goToClient = (clientId) => { onClose(); nav(`/admin/clientes/${clientId}`); };
  const withSites = data ? data.filter((c) => c.sites.length > 0) : [];
  const withoutSites = data ? data.filter((c) => c.sites.length === 0) : [];

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="sites-overview-modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 640, maxHeight: "80vh", overflowY: "auto" }} data-testid="sites-overview-modal">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
          <h3 style={{ margin: 0 }} data-testid="sites-overview-title">
            {mode === "sites" ? `Sedes activas (${totalSites})` : `Objetivos activos (${data?.length ?? 0})`}
          </h3>
          <button onClick={onClose} className="btn-ghost" style={{ padding: 6 }} data-testid="sites-overview-close"><X size={16} /></button>
        </div>
        <p style={{ fontSize: 12, color: "var(--invict-text-muted)", margin: "0 0 14px" }}>
          {mode === "sites"
            ? "Agrupadas por objetivo. Si ves una sede que no reconocés, entrá a su ficha para desactivarla."
            : "Los objetivos activos que suma la métrica del inicio."}
        </p>
        {err && <div className="card" style={{ borderColor: "#BF3437", color: "#8E2629" }}>{err}</div>}
        {!data && !err && <div className="skel" style={{ height: 120 }} />}

        {data && mode === "clients" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }} data-testid="sites-overview-clients-list">
            {data.map((c) => (
              <button key={c.client_id} onClick={() => goToClient(c.client_id)} data-testid={`sites-overview-client-${c.client_id}`}
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", textAlign: "left", padding: "10px 12px", border: "1.5px solid var(--invict-bone-3)", borderRadius: 4, background: "white", cursor: "pointer" }}>
                <span style={{ fontWeight: 700, fontSize: 13, color: "#0A0A0A" }}><Building2 size={13} style={{ marginRight: 6, verticalAlign: "-2px" }} />{c.client_name}</span>
                <span style={{ fontSize: 11, color: "var(--invict-text-muted)" }}>{c.sites.length} sede{c.sites.length !== 1 ? "s" : ""}</span>
              </button>
            ))}
          </div>
        )}

        {data && mode === "sites" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }} data-testid="sites-overview-sites-list">
            {withSites.map((c) => (
              <div key={c.client_id}>
                <div style={{ fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.06em", color: "#0A0A0A", marginBottom: 6 }}>
                  <Building2 size={12} style={{ marginRight: 5, verticalAlign: "-2px" }} />{c.client_name} · {c.sites.length}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  {c.sites.map((s) => (
                    <button key={s.id} onClick={() => goToSite(c.client_id, s.id)} data-testid={`sites-overview-site-${s.id}`}
                      style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", textAlign: "left", padding: "8px 12px", border: "1px solid var(--invict-bone-3)", borderRadius: 4, background: "var(--invict-bone-2)", cursor: "pointer" }}>
                      <span style={{ fontSize: 12, color: "#0A0A0A" }}><MapPin size={11} style={{ marginRight: 5, verticalAlign: "-1px" }} />{s.name}</span>
                      <span style={{ fontSize: 11, color: "var(--invict-text-muted)", display: "inline-flex", alignItems: "center", gap: 4 }}><Users size={11} />{s.assigned_vigilador_ids.length}</span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
            {withoutSites.length > 0 && (
              <div style={{ fontSize: 11, color: "var(--invict-text-muted)" }} data-testid="sites-overview-no-sites-hint">
                {withoutSites.length} objetivo(s) sin sedes cargadas (no suman a esta métrica): {withoutSites.map((c) => c.client_name).join(", ")}.
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
